// extracted by mini-css-extract-plugin
export default {"time":"blockedPeriod_time__tjFdU"};